import { useEffect, useMemo, useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { closeProfileModal } from "../../../app/redux/features/profile/profileSlice";
import { Field, FormikProvider, useFormik } from "formik";
import FieldInputText from "../../../app/modules/common/FieldInputText";
import SubmitButton from "../../../app/modules/common/SubmitButton";
import * as Yup from 'yup'
import { MESSAGES } from "../../../app/utlis/messages";
import { GetProfileDetails, updateProfile } from "../../../app/redux/features/profile/profileActions";


const validationSchema = Yup.object({
  supplier_code: Yup.string().required(MESSAGES.SUPPLIER_CODE_REQUIRED),
  rag_soc: Yup.string().required(MESSAGES.REG_SOC_REQUIRED),
  email: Yup.string().email(MESSAGES.INVALID_EMAIL_MESSAGE).required(MESSAGES.EMAIL_REQUIRED),
  username: Yup.string().required(MESSAGES.USERNAME_REQUIRED),
});


const ProfileModal = () => {
  const dispatch: any = useDispatch();
  const { openProfileDetailModal, loading } = useSelector(
    (state: any) => state.profileDetailsSlice
  );
  const [profileDetails, setProfileDetails] = useState<any>(null);

  // Fetch profile details on modal open
  useEffect(() => {
    if (openProfileDetailModal) {
      dispatch(GetProfileDetails()).then((response) => {
        setProfileDetails(response?.payload?.data);
      }).catch((error) => {
        console.error("Failed to fetch profile details:", error);
      });
    }
  }, [openProfileDetailModal]);

  // Memoized initial values
  const initialValues = useMemo(() => ({
    supplier_code: Array.isArray(profileDetails?.supplier_code) ? profileDetails?.supplier_code.join(', ') : profileDetails?.supplier_code || '',
    rag_soc: profileDetails?.rag_soc || '',
    email: profileDetails?.email || '',
    username: profileDetails?.username || ''
  }), [profileDetails]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        await dispatch(updateProfile({ values }));
        handleClose();
      } catch (error) {
        console.error("Registration failed:", error);
      }
    },
  });

  // Detect modal close and reset form
  const prevOpenRef = useRef<boolean>(openProfileDetailModal);
  useEffect(() => {
    if (prevOpenRef.current && !openProfileDetailModal) {
      formik.resetForm();
    }
    prevOpenRef.current = openProfileDetailModal;
  }, [openProfileDetailModal]);

  const handleClose = () => {
    dispatch(closeProfileModal());
  };


  return (
    <Modal show={openProfileDetailModal} onHide={handleClose} centered size="sm">
      <Modal.Header closeButton className="bg-light text-black position-relative">
        <Modal.Title>{MESSAGES.PROFILE_DETAILS}</Modal.Title>
      </Modal.Header>


      <Modal.Body>
        {loading ? (
          <div className="d-flex justify-content-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit} noValidate>

              <div className="row">
                <div className="col-md-12">
                  <Field name="supplier_code" label={MESSAGES.SUPPLIER_CODE} required component={FieldInputText} readOnly />
                </div>
                {/* <div className="col-md-6">
                  <Field name="rag_soc" label={MESSAGES.RAG_SOC} required component={FieldInputText} />
                </div> */}

                <div className="col-md-12">
                  <Field name="email" label={MESSAGES.EMAIL} required component={FieldInputText} readOnly />
                </div>
                {/* <div className="col-md-6">
                  <Field name="username" label={MESSAGES.USERNAME} required component={FieldInputText} />
                </div> */}
              </div>

              {/* <div className="d-grid mt-3">
                <SubmitButton title={MESSAGES.SAVE_CHANGES} type="submit" loading={false} />
              </div> */}
            </form>
          </FormikProvider>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ProfileModal;
